// extracted by mini-css-extract-plugin
export default {"error":"UserModal_error__Ah-gf"};